var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '../Box';
import { Card } from '../Card';
import { Flex } from '../Flex';
import { Text } from '../Text';
import { applyVariations, deprecatedColorValue } from '../utils';
var HugCard = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  ", "\n"], ["\n  overflow: hidden;\n  ", "\n"])), applyVariations('Hug'));
var BorderConcealer = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & > * {\n    border: 0 !important;\n  }\n"], ["\n  & > * {\n    border: 0 !important;\n  }\n"])));
var propTypes = {
    iconDisplay: PropTypes.arrayOf(PropTypes.string),
    icon: PropTypes.node,
    text: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node), PropTypes.string]),
    color: deprecatedColorValue(),
    borderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
var Hug = function (_a) {
    var bg = _a.bg, color = _a.color, p = _a.p, fontSize = _a.fontSize, icon = _a.icon, iconDisplay = _a.iconDisplay, props = __rest(_a, ["bg", "color", "p", "fontSize", "icon", "iconDisplay"]);
    var iconClone;
    if (React.isValidElement(icon)) {
        iconClone = React.cloneElement(icon, {
            style: { display: iconDisplay },
            mr: 2,
            mt: '-2px',
            mb: '2px',
            size: 24,
        });
    }
    return (React.createElement(HugCard, __assign({}, props, { borderColor: bg || color }),
        React.createElement(Flex, { bg: bg, color: color, p: p, pl: '12px', alignItems: 'center' },
            !!iconClone && iconClone,
            React.createElement(Text, { fontSize: fontSize }, props.text)),
        React.createElement(BorderConcealer, null, props.children)));
};
Hug.defaultProps = {
    borderRadius: 'xl',
    borderWidth: 1,
    color: 'text.lightest',
    fontSize: 1,
    p: 2,
};
Hug.propTypes = propTypes;
export default Hug;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Hug.js.map